import React from 'react';
import * as Yup from 'yup';

import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import FormikInput from 'src/components/formik/FormikInput';
import FormikSelect from 'src/components/formik/FormikSelect';
import FormikChipAutocomplete from 'src/components/formik/FormikChipAutocomplete';

import { FIELD_OPTIONS, RADIO, SELECT } from 'src/views/constants/fieldConstants';
import { Field } from 'src/types';
import useGetRequest from 'src/hooks/useGetRequest';

interface Props {
  onSuccess: () => void,
  workflowId: string,
  context?: Field,
  onClose: () => void,
}

function FieldForm({
  onSuccess, workflowId, context, onClose
}: Props) {
  const fieldId = context && context.id;
  const {
    result: field,
    isLoading,
  } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/table/fields/${fieldId}/`,
    shouldFetchOnInitialRender: Boolean(fieldId),
    initialResult: { options: [] },
  });

  if (isLoading) return null;

  const fieldsConfig = [
    {
      name: 'name',
      component: () => (
        <FormikInput
          fullWidth
          label="Name"
          name="name"
          required
          disabled={Boolean(fieldId)}
        />
      ),
      validator: Yup.string().required('This field is required.'),
      gridProps: { xs: 6 },
    },
    {
      name: 'type',
      component: () => (
        <FormikSelect
          fullWidth
          label="Type"
          name="type"
          options={FIELD_OPTIONS}
          disabled={Boolean(fieldId)}
        />
      ),
      validator: Yup.string().required('This field is required.'),
      gridProps: { xs: 6 },
    },
    {
      name: 'options',
      component: () => (
        <FormikChipAutocomplete
          name="options"
          freeSolo
          options={field.options}
          label="Options"
          placeholder="Enter options here"
          helperText="Hit the enter key between options"
        />
      ),
      // validator: Yup.string().required('This field is required.'),
      shouldRender: (formik: any) => [SELECT, RADIO].includes(formik.values.type),
    },
  ];

  return (
    <CRUDConfigForm
      url={`/automatic/workflows/${workflowId}/table/fields/`}
      objectId={fieldId}
      onSuccess={onSuccess}
      fieldsConfig={fieldsConfig}
      includeDeleteButton
      secondaryButton={{
        label: 'Cancel',
        onClick: onClose,
      }}
    />
  );
}

export default FieldForm;
